export default {
  // 按钮文本
  addButton: '新增',
  editButton: '编辑',
  deleteButton: '删除',
  cancelButton: '取消',
  confirmButton: '确定',

  // 表格列标题
  dictNameColumn: '字典名称',
  dictIdColumn: '字典ID',
  orderColumn: '排序',
  statusColumn: '状态',
  actionColumn: '操作',

  // 状态
  statusNormal: '正常',

  // 表单标签
  parentDictLabel: '上级字典',
  dictNameLabel: '字典名称',
  orderLabel: '显示排序',

  // 表单placeholder
  parentDictPlaceholder: '请选择上级字典',
  orderPlaceholder: '填写排序',

  // 验证消息
  dictNameRequired: '请输入字典名称',
  dictIdRequired: '请输入字典ID',

  // 弹窗标题
  addTitle: '新增字典',
  editTitle: '修改字典',

  // 成功消息
  addSuccess: '新增成功',
  editSuccess: '修改成功',
  deleteSuccess: '删除成功',

  // 树选择
  mainCategory: '主类目',
}
